/**
 * Default: Initial
 */

import {setRootVar} from '@ifabnpm/bootstrap/utils.js';
import {focusVisible} from '@ifabnpm/bootstrap/utils/focus-visible.js';
import {scrollTop} from '@ifabnpm/bootstrap/utils/scroll.js';
import {load} from '@ifabnpm/bootstrap/utils/load.js';
import lazyLoad from '@ifabnpm/bootstrap/utils/lazy-load.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

/**
 * Monitor ´document.documentElement´ changes.
 *
 * @type {MutationObserver}
 */
const observerDocumentMutation = new MutationObserver((mutations) => {
	EventHandler.trigger(document.documentElement, 'ifab.documentMutation', {
		mutations
	});
});

const observerDocHeight = () => {
	const calc = () => {
		setRootVar(`global-vh`, `${window.innerHeight/100}px`);
	};

	window.addEventListener('resize', calc);
	window.addEventListener('orientationchange', calc);

	calc();
};

/**
 * Accessibility (`:focus` erst bei Tastaturnavigation anzeigen.)
 */
const handleFocusableElements = () => {
	const collection = SelectorEngine.find('input, textarea, select, label, a, button');

	for (const element of collection) {
		focusVisible.observe(element);
	}
};

const bindLazyload = () => {
	// Fehlerbehandlung von ´fehlenden Bildern´ anbinden.
	const images = SelectorEngine.find('img');

	for (const image of images) {
		EventHandler.on(image, 'error', (event) => {
			Manipulator.addClass(event.target, 'is-faulty');
		});
	}

	// Lazyload initialisieren.
	lazyLoad(function () {
		const lazyElements = SelectorEngine.find('.lazyload[data-src]');

		if (lazyElements) {
			window.lazySizesConfig = window.lazySizesConfig || {};
			window.lazySizesConfig.loadMode = 1;

			load(`${window.pageInstance.path.dist}vendors/lazysizes/lazysizes.min.js`).then(() => {
				// Do nothing...
			});
		}
	});
};

// -------
// Public
// -------

const index = () => {
	observerDocumentMutation.observe(document.documentElement, {
		attributes: true
	});

	observerDocHeight();
	bindLazyload();
	handleFocusableElements();

	// ´History back´ - Buttons
	EventHandler.on(document.body, 'click', 'button[data-history-back]', (event) => {
		event.preventDefault();
		event.stopPropagation();

		history.back();
	});

	// ´Scroll top´ - Elwmente
	EventHandler.on(document, 'click', '[data-scroll-top]', (event) => {
		// preventDefault only for <a> elements (which change the URL) not inside the collapsible element
		if (
			event.target.tagName.toLowerCase() === 'a' ||
			(event.delegateTarget && event.delegateTarget.tagName.toLowerCase() === 'a')
		) {
			event.preventDefault();
		}

		scrollTop().then(element => {
			// `element` = zu ihm wird gescrollt
			// Do nothing ...
		});
	});

	// ...globalen ´Scroll top´-Button integrieren
	const scrollTopTrigger = SelectorEngine.findOne('button[data-scroll-top="global"]');

	if (scrollTopTrigger) {
		document.addEventListener('scroll', function () {
			requestAnimationFrame(() => {
				if (window.scrollY > window.innerHeight) {
					Manipulator.addClass(scrollTopTrigger, '-show');
				} else {
					Manipulator.removeClass(scrollTopTrigger, '-show');
				}
			});
		});
	}
};

// Export
export default index;
